/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RecommendationMonitorSetStatusDto = {
    status: RecommendationMonitorSetStatusDto.status;
};

export namespace RecommendationMonitorSetStatusDto {

    export enum status {
        PENDING = 'PENDING',
        ACCEPTED = 'ACCEPTED',
        REFUSED = 'REFUSED',
    }


}
